import { Directive, InjectionToken } from '@angular/core';

export const AD_SUPPORT: any = new InjectionToken<AtSupport>('atSupport');

@Directive({
  selector: '[atSupport]',
  providers: [{provide: AD_SUPPORT, useExisting: AtSupport}]
})
export class AtSupport {}
